import { createContext, Dispatch, SetStateAction, useCallback, useContext, useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { getAccessToken } from '../../api/auth'
import LottieLoading from '../LottieLoading'
import LogInCenterModal from '../myshopping/LogInCenterModal'
import LogInModal from '../myshopping/LogInModal'

const CommonContext = createContext<{
  isLottie: boolean
  setIsLottie: Dispatch<SetStateAction<boolean>>
  allSearch: any
  setAllSearch: Dispatch<SetStateAction<any>>
  isLogin: boolean
  setIsLogin: Dispatch<SetStateAction<boolean>>
  hasAccessToken: boolean
  setHasAccessToken: Dispatch<SetStateAction<boolean>>
}>({
  isLottie: false,
  setIsLottie: () => {},
  allSearch: [],
  setAllSearch: () => {},
  isLogin: false,
  setIsLogin: () => {},
  hasAccessToken: false,
  setHasAccessToken: () => {},
})

const CommonProvider = ({ children }: { children: any }) => {
  const [isLottie, setIsLottie] = useState<boolean>(false)
  const [allSearch, setAllSearch] = useState<any>([])
  const [isLogin, setIsLogin] = useState<boolean>(false)
  const [loggedIn, setLoggedIn] = useState<boolean>(false)
  const [hasAccessToken, setHasAccessToken] = useState<boolean>(false)
  const [isCheckAccessToken, setIsCheckAccessToken] = useState(getAccessToken()) // 토큰 상태 관리

  useEffect(() => {
    const checkLogin = getAccessToken()
    if (checkLogin) {
      setLoggedIn(true)
    } else {
      setLoggedIn(false)
    }
  }, [location, setIsLogin])

  const checkLogin = useCallback(() => {
    const token = getAccessToken()
    setHasAccessToken(!!token)
  }, [])

  useEffect(() => {
    checkLogin()
  }, [checkLogin, isCheckAccessToken]) // accessToken이 변경될 때만 실행

  // 토큰 값 변경 감지 (예: Polling 또는 이벤트)
  useEffect(() => {
    const interval = setInterval(() => {
      const token = getAccessToken()
      setIsCheckAccessToken(token) // accessToken을 업데이트
    }, 1000) // 1초마다 토큰 확인

    return () => clearInterval(interval) // 컴포넌트 언마운트 시 정리
  }, [])

  return (
    <CommonContext.Provider
      value={{
        isLottie,
        setIsLottie,
        allSearch,
        setAllSearch,
        isLogin,
        setIsLogin,
        hasAccessToken,
        setHasAccessToken,
      }}
    >
      {isLottie && <LottieLoading></LottieLoading>}

      {children}

      {/* PC일 때 */}
      {!isMobile && isLogin && !loggedIn ? <LogInCenterModal setLoggedIn={setLoggedIn}></LogInCenterModal> : null}
      {/* // 모바일 일 떄  */}
      {isMobile && isLogin && !loggedIn ? <LogInModal setLoggedIn={setLoggedIn}></LogInModal> : null}
    </CommonContext.Provider>
  )
}

const useCommonContext = () => {
  const context = useContext(CommonContext)
  if (!context) {
    throw new Error('useCommonContext 가 CommonProvider 안에서 사용되지 않았습니다.')
  }
  return context
}

export { CommonContext, CommonProvider, useCommonContext }
